import loadable from '@loadable/component';
import LoadingComponent from 'components/Loaders/LoadingComponent';

const AmifLoadable = loadable(() => import(/* webpackChunkName: 'retailer-Amif' */ './Amif'), {
  fallback: <LoadingComponent />,
});

export default AmifLoadable;
